<template>
  <b-modal
    id="updateModal"
    title='Updating "Data Server"'
    button-size="sm"
    content-class="rounded-8"
    centered
    hide-footer
  >
    <div v-if="!status">
      <p>Do you want to download a new version?</p>
      <p>Please make sure there are no active data transfers.</p>
      <p class="reloadWrapper">
        <b-button variant="outline-primary" size="sm" class="btn-delete-device" @click="clickUpdateLicense">
          {{ 'update' | i18n }}
        </b-button>
      </p>
    </div>
    <div v-if="status === 'updating'">
      <p style="text-align:center">
        Data Server is updaiting now...
      </p>
      <div style="height:100px">
        <div class="loader">
          Loading...
        </div>
      </div>
    </div>
    <div v-if="status === 'done'">
      <p style="text-align:center">
        Data Server is updated
      </p>
      <p style="text-align:center">The page will be automatically refreshed in {{ seconds }} sec</p>
      <div style="height:100px;display: flex;justify-content: center;">
        <img :src="successIcon" style="width:100px" />
      </div>
    </div>
  </b-modal>
</template>

<script>
import { UpdateMixin, NotificationMixin } from '../../mixins';
import successIcon from '../../assets/icons/success.svg';

let timeOutId = null;
export default {
  name: 'UpdateModal',
  mixins: [UpdateMixin, NotificationMixin],
  data: function() {
    return {
      status: null,
      successIcon: successIcon,
      seconds: 10
    };
  },
  methods: {
    async clickUpdateLicense() {
      console.log('start update');
      await this.updateServer();
      this.status = 'updating';
      timeOutId = setInterval(async () => {
        const result = await this.getUpdateStatus();
        console.log(result, 'status');
        if (result.status) {
          clearInterval(timeOutId);
          this.status = 'done';
          console.log('updated');
          setInterval(() => {
            this.seconds -= 1;
            if (this.seconds === 0) {
              window.location.reload(true);
            }
          }, 1000);
        }
      }, 2000);
    }
  }
};
</script>

<style scoped>
.reloadWrapper {
  display: flex;
  justify-content: center;
}
label {
  color: #7586a5;
}

.loader,
.loader:before,
.loader:after {
  background: #828895;
  -webkit-animation: load1 1s infinite ease-in-out;
  animation: load1 1s infinite ease-in-out;
  width: 1em;
  height: 4em;
}
.loader {
  color: #828895;
  text-indent: -9999em;
  margin: 88px auto;
  position: relative;
  font-size: 11px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.loader:before,
.loader:after {
  position: absolute;
  top: 0;
  content: '';
}
.loader:before {
  left: -1.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.loader:after {
  left: 1.5em;
}
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}
::v-deep .rounded-8 {
  border-radius: 8px;
}
@-webkit-keyframes load1 {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 4em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 5em;
  }
}
@keyframes load1 {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 4em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 5em;
  }
}
</style>
